import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProfileGuard } from '@guards/profile/profile.guard';

import { MarsGroupsComponent } from './components/mars-groups/mars-groups.component';
import { MarsGroupComponent } from './components/mars-group/mars-group.component';

import { ClientResolver, CountriesResolver, LocalesResolver } from 'core/resolvers';
import { MarsGroupResolver } from './resolvers/mars-group.resolver';

// todo prescindir de courses, game ...

const routes: Routes = [
  {
    path: 'mars',
    title: 'marsPrent',
    resolve: {
      locales: LocalesResolver,
      countries: CountriesResolver
    },
    children: [
      {
        path: '',
        title: 'marsList',
        component: MarsGroupsComponent,
        canActivate: [ProfileGuard],
        data: { action: 'mars.list' },
        resolve: {
          client: ClientResolver
        }
      },
      {
        path: 'new',
        title: 'newMarsGroup',
        component: MarsGroupComponent,
        resolve: {
          client: ClientResolver
        },
        canActivate: [ProfileGuard],
        data: {
          action: 'mars.create',
          questionsDataScheme: { client: 'data.client' }
        }
      },
      {
        path: ':groupId',
        title: 'marsGroupId',
        resolve: {
          group: MarsGroupResolver
        },
        children: [
          {
            path: '',
            title: 'marsGroupIdDetail',
            component: MarsGroupComponent,
            canActivate: [ProfileGuard],
            resolve: {
              client: ClientResolver
            }
          }
        ],
        data: {
          action: 'mars.detail',
          microfrontends: ['GlReports'],
          questionsDataScheme: {
            client: 'data.client',
            group: 'data.group',
            course: 'data.course',
            groupGameData: 'data.groupGameData',
            hasBonus: 'data.group.hasBonus'
          }
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MarsRoutingModule {}
